import stars from '_assets/img/onboard/bg/stars-and-quote.svg';
import Button from '_atoms/Button/Button';
import React, { useState } from 'react';

import i18n from '_i18n';
import { termsAndConditionsUrl } from 'Helper/Terms';
import useStripeCheckout, {
    CheckoutStripeProps,
} from 'Hooks/useStripeCheckout';
import { useTranslation } from 'react-i18next';
import './SubscriptionOnboardingChoice.scss';

const TEXTS = () => {
    return {
        en: {
            header: 'Over 11,000 have an active subscription.<br/>More than 90% choose to renew it.',
            quote: '100% worth the money!<br/>It has everything you could need and more.',
            name: '– Karoline',
            notNow: 'Not now',
            terms: 'Terms & Conditions',
        },
        no: {
            header: 'Over 11 000 har et aktivt abonnement.<br/>Mer enn 90% velger å fornye det.',
            quote: '100% verdt pengene! Den har alt en kunne trenge og litt til.',
            name: '– Karoline',
            notNow: 'Ikke nå',
            terms: 'Betingelser og vilkår',
        },
    };
};

interface SubscriptionOnboardingChoiceProps {
    onAnswer: (answerIndexes: number[]) => void;
}

const SubscriptionOnboardingChoice: React.FC<
    SubscriptionOnboardingChoiceProps
> = ({ onAnswer }) => {
    const language = i18n.language === 'no' ? 'no' : 'en';
    const texts = TEXTS()[language];
    const { t } = useTranslation();

    const { onCheckoutButtonClick } = useStripeCheckout();

    const [isLoading, setIsLoading] = useState(false);

    function startSubscription(): void {
        const checkoutParams: CheckoutStripeProps = {
            interval: 'year',
            trial: true,
            discount: '',
            onDone: () => {
                setIsLoading(false);
            },
            success_url: `${window.location.href}?checkoutSuccess=true`,
        };
        setIsLoading(true);

        onCheckoutButtonClick(checkoutParams);
    }

    const quoteBox = (
        <div className="subscription-onboarding-quoteBox">
            <img src={stars} alt="background" />
            <div>
                <div
                    className="quote-header"
                    dangerouslySetInnerHTML={{ __html: texts.quote }}
                ></div>
                <div className="quote-name">{texts.name}</div>
            </div>
        </div>
    );
    return (
        <div className="subscription-onboarding-screen">
            <div className="subscription-onboarding-content">
                <div
                    className="subscription-onboarding-header"
                    dangerouslySetInnerHTML={{ __html: texts.header }}
                />
                {quoteBox}
                <Button
                    classes="subscription-onboarding-btn"
                    isDisabled={isLoading}
                    isLoading={isLoading}
                    onClick={() => startSubscription()}
                >
                    {t('Start trial')}
                </Button>
                <Button
                    type="tertiary"
                    size="small"
                    classes="subscription-onboarding-no-thx"
                    onClick={() => {
                        onAnswer([4]);
                    }}
                >
                    {texts.notNow}
                </Button>
            </div>

            <div className="subscription-onboarding-bottom">
                <Button
                    type="tertiary"
                    size="small"
                    classes="subscription-onboarding-terms"
                    onClick={() => {
                        window.open(
                            termsAndConditionsUrl,
                            '_blank',
                            'noopener,noreferrer',
                        );
                    }}
                >
                    {texts.terms}
                </Button>
            </div>
        </div>
    );
};

export default SubscriptionOnboardingChoice;
